// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvh9hh{padding-left:var(--ds-space-100,4px)}\n._ca0q1b66{padding-top:var(--ds-space-050,4px)}\n._n3td1b66{padding-bottom:var(--ds-space-050,4px)}\n._u5f3h9hh{padding-right:var(--ds-space-100,4px)}\n._1u6lglyw:focus-within{box-shadow:none}", ""]);
// Exports
module.exports = exports;
